import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from './../../../../shared/services/profile.service';
import { StudentsService } from 'src/app/shared/services/students.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlStudentSchoolFieldTrip, StudentFieldTripDataService } from '../../student-list-widget/models/SchoolFiledTripModel';

@Component({
  selector: 'app-student-fieldtrip',
  templateUrl: './student-fieldtrip.component.html',
  styleUrls: ['./student-fieldtrip.component.scss']
})
export class StudentFieldtripComponent implements OnInit {
  selectedTripModel: MdlStudentSchoolFieldTrip = null;
  studentId: string = "";

  //Binding from backend
  headerTitle = "PARENT'S/GUARDIAN'S PERMISSION FOR A FIELD TRIP & AUTHORIZATION FOR MEDICAL CARE - TRIP SLIP";
  studentName: string = "";

  //Input fileds
  // parentGuardianName: string = "";
  // parentGuardianNameErrorMsg: string = "";
  // isParentGuardianNameValid: boolean = false;

  // parentGuardianDate: string = this.getTodayDate();
  // parentGuardianDateErrorMsg: string = "";
  // isParentGuardianDateValid: boolean = false;

  parentGuardianName2: string = "";
  parentGuardianName2ErrorMsg: string = "";
  isParentGuardianName2Valid: boolean = false;

  parentGuardianDate2: string = this.getTodayDate();
  parentGuardianDate2ErrorMsg: string = "";
  isParentGuardianDate2Valid: boolean = false;

  consentParentGuardianName: string = "";
  consentParentGuardianSignature: string = "";

  homeTelePhone: string = "";
  busineesTelePhone: string = "";
  isValidFormSubmit: boolean = false;

  emergencyTelePhone: string = "";
  emergencyPhErrorMsg: string = "";
  isEmergencyPhValid: boolean = false;
  studentNameInput: string = "";
  consentMedicalTreatments: boolean = false;
  consentTripRadioBtnValue: string = "";
  fieldTripConsent: string = '';
  consentTrip: boolean = true;
  isConsentTrip: boolean = true;
  consentTripErrorMsg: string = "";

  consentSignature: boolean = false;
  isConsentSignature: boolean = false;
  consentSignatureErrorMsg: string = "";

  isRequestProcessing: boolean = false;

  constructor(private toastr: ToastrService,
    private studentService: StudentsService,
    private profileService: ProfileService,
    private activeRoute: ActivatedRoute,
    private dataService: StudentFieldTripDataService,
    private router: Router
  ) { }

  ngOnInit(): void {

    const currentUser = this.profileService.identity;
    if (currentUser.userType.toLowerCase() == "student") {
      this.studentId = currentUser.userIdRole;
    }
    else if (currentUser.userType.toLowerCase() == "parent") {
      this.activeRoute.parent.params.subscribe((data) => {
        console.log(data)
        this.studentId = data.studentId;
      });
    }

    this.dataService.currentModel.subscribe(data => {
      this.selectedTripModel = data;
      if (this.selectedTripModel) {
        if (!this.selectedTripModel) {
          this.router.navigate(['/parent/students/' + this.studentId + '/fieldtrip']);
        }
        var acknowledgeName = this.selectedTripModel.acknowlegedBY;
       // this.parentGuardianName = acknowledgeName;
        this.parentGuardianName2 = acknowledgeName;
        this.consentParentGuardianName = acknowledgeName;
        this.consentParentGuardianSignature = this.selectedTripModel.sign;

        if (this.selectedTripModel.acknowlegedOn) {
          var dateValue = this.selectedTripModel.acknowlegedOn;
          //this.parentGuardianDate = dateValue;
          this.parentGuardianDate2 = dateValue;
        }
        this.homeTelePhone = this.selectedTripModel.homeContact;
        this.busineesTelePhone = this.selectedTripModel.businessContact;
        this.emergencyTelePhone = this.selectedTripModel.emergencyContact;
        this.consentMedicalTreatments = this.selectedTripModel.consentMedicalTreatments;
        if (this.selectedTripModel.consentTrip) {
          this.fieldTripConsent = "Yes";
          this.consentTrip = true;
        }
        else {
          this.fieldTripConsent = "No";
          this.consentTrip = false;
        }
        this.consentSignature = this.selectedTripModel.consentSignature;
      }
    });

    this.studentName = document.getElementById("studentReadName").innerHTML;
    this.studentNameInput = this.studentName;
  }

  onSubmit() {
    //Validations
    this.formFieldsValidation();
  }

  onCancel() {
    this.router.navigate(['/parent/students/' + this.studentId + '/fieldtrip']);
  }

  onFieldTripConsentChange(value: string) {
    this.consentTripRadioBtnValue = value;
    if (value === "Yes") {
      this.consentTrip = true;
    }
    else {
      this.consentTrip = false;
    }
  }

  formFieldsValidation() {
    this.isValidFormSubmit = false;
    
    //Parent/Guardian Name 
    // this.isParentGuardianNameValid = false;
    // if (!this.parentGuardianName) {
    //   this.parentGuardianNameErrorMsg = "Parent/Guardian Name is required."
    //   this.isParentGuardianNameValid = true;
    //   this.isValidFormSubmit = true;
    // }
    //Parent/Guardian Date      
    // this.isParentGuardianDateValid = false;
    // if (!this.parentGuardianDate) {
    //   this.parentGuardianDateErrorMsg = "Date is required."
    //   this.isParentGuardianDateValid = true;
    //   this.isValidFormSubmit = true;
    // }

    //Emergency Phone Number   
    this.isEmergencyPhValid = false;
    if (!this.emergencyTelePhone) {
      this.emergencyPhErrorMsg = "Emergency Telephone is required."
      this.isEmergencyPhValid = true;
      this.isValidFormSubmit = true;
    }
    else if (this.emergencyTelePhone.length !== 14) {
      this.emergencyPhErrorMsg = "Invalid Emergency Telephone Number."
      this.isEmergencyPhValid = true;
      this.isValidFormSubmit = true;
    }

    //Parent/Guardian Name 2
    this.isParentGuardianName2Valid = false;
    if (!this.parentGuardianName2) {
      this.parentGuardianName2ErrorMsg = "Parent/Guardian Name is required."
      this.isParentGuardianName2Valid = true;
      this.isValidFormSubmit = true;
    }

    this.isConsentSignature = false;
    if (!this.consentSignature) {
      this.consentSignatureErrorMsg = "Consent Signature selection is required."
      this.isConsentSignature = true;
      this.isValidFormSubmit = true;
    }

    //Parent/Guardian Date 2       
    this.isParentGuardianDate2Valid = false;
    if (!this.parentGuardianDate2) {
      this.parentGuardianDate2ErrorMsg = "Date is required."
      this.isParentGuardianDate2Valid = true;
      this.isValidFormSubmit = true;
    }

    if (this.isValidFormSubmit) {
      this.isRequestProcessing = false;
      this.toastr.warning("Please complete all required fields before submitting the form.", '');
      return;
    }

    // Submit the Form Details  
    this.isRequestProcessing = true;
    const todayDate = this.getTodayDate();
    let requestForm = {
      studentName: this.studentName,
      school: this.selectedTripModel.school,
      primaryContact: this.selectedTripModel.primaryContact,
      destination: this.selectedTripModel.destination,
      depatureDate: this.selectedTripModel.depatureDate,
      depatureTime: this.selectedTripModel.depatureTime,
      returnDate: this.selectedTripModel.returnDate,
      returnTime: this.selectedTripModel.returnTime,
      isLunchProvided: this.selectedTripModel.isLunchProvided,
      transportMode: this.selectedTripModel.transportMode,

      homeContact: this.homeTelePhone,
      businessContact: this.busineesTelePhone,
      emergencyContact: this.emergencyTelePhone,
      consentMedicalTreatments: this.consentMedicalTreatments,
      consentTrip: true,
      consentSignature: this.consentSignature,     
      acknowlegedBY: this.parentGuardianName2,
      acknowlegedOn: todayDate      
    };

    this.studentService.submitScholFieldTripForm(this.studentId,
      this.selectedTripModel.tripRefNo, requestForm).subscribe(
        (result) => {
          if (typeof (result.error) !== 'undefined' && typeof (result.status) !== 'undefined') {
            this.isRequestProcessing = false;
            this.toastr.error("Form Submission Failed.", "");
          }
          else {
            this.isRequestProcessing = false;
            this.toastr.success("Form has been Submitted Successfully.", "");
            this.router.navigate(['/parent/students/' + this.studentId + '/fieldtrip']);
          }
        },
        (error) => {
          this.isRequestProcessing = false;
          this.toastr.error("Form has been Submitted Successfully.", "");
        }
      );
  }

  getTodayDate(): string {
    const date = new Date();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  }

  onPhoneNumberChange(val: string, control: string) {
    var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/); if (x != null) val = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    if (control == "homeTelePhone") {
      this.homeTelePhone = val;
    }
    else if (control == "busineesTelePhone") {
      this.busineesTelePhone = val;
    }
    else if (control == "emergencyTelePhone") {
      this.emergencyTelePhone = val;
    }
  }

  onAlphabetsOnly(event: any) {
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) ||
      (charCode > 96 && charCode < 123) ||
      charCode == 8 || charCode == 32) {
      return true;
    }
    else {
      return false;
    }
  }
}
